import { useEffect, useState } from 'react';
import { Cancel } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Users } from '../../../icons/users';
import { PaperAirplane } from '../../../icons/paper-airplane';
import { Mail } from '../../../icons/mail';
import { EngagementStatusEnum } from '../../../consts/enums';
import { StatisticsCard } from '../../../@types/statistic';
import StatisticsBar from '../../../components/StatisticsBar';
import STRING_KEYS from '../../../language/keys';
import { useStatistics } from '../../../hooks/query/useStatistics';
import style from './style';

type Props = {
  positionId?: string,
  accountId?: string,
}
export default function PositionStatusesAndTasks({ positionId, accountId }: Props): JSX.Element {
  const { t: translate } = useTranslation();
  const { matches, loadStatistics } = useStatistics(positionId, accountId);

  const [matchStatuses, setMatchStatuses] = useState<StatisticsCard[]>([
    {
      title: translate(STRING_KEYS.STATISTICS.ALL_MATCHES),
      key: 'ALL',
      amount: 0,
      icon: (
        <Users
          viewBox={ style.icon.viewBox }
          sx={ style.icon.statisticsSx }
        />),
    },
    {
      title: translate(STRING_KEYS.ENGAGEMENT_STATUS.PENDING_REVIEW),
      key: EngagementStatusEnum.pendingPreview,
      amount: 0,
      icon: (
        <PaperAirplane
          viewBox={ style.icon.viewBox }
          sx={ style.icon.statisticsSx }
        />),
    },
    {
      title: translate(STRING_KEYS.ENGAGEMENT_STATUS.DECLINED),
      key: EngagementStatusEnum.declined,
      amount: 0,
      icon: (
        <Cancel
          sx={ style.icon.statisticsSx }
        />),
    },
    {
      title: translate(STRING_KEYS.ENGAGEMENT_STATUS.ENGAGED),
      key: EngagementStatusEnum.engaged,
      amount: 0,
      icon: (
        <Mail
          viewBox={ style.icon.viewBox }
          sx={ style.icon.statisticsSx }
        />),
    },
  ]);

  useEffect(() => {
    if (!loadStatistics && matches) {
      const updatedMatchStatuses = matchStatuses.map((statisticCard: StatisticsCard) => {
        if (matches[statisticCard.key]) {
          statisticCard.amount = matches[statisticCard.key];
        }

        return statisticCard;
      });
      setMatchStatuses(updatedMatchStatuses);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadStatistics]);

  return (
    <Box
      sx={ style.main.sx }
    >
      <StatisticsBar
        loading={ loadStatistics }
        statistics={ matchStatuses }
        title={ translate(STRING_KEYS.STATISTICS.MATCH_TITLE) }
      />
    </Box>
  );
}

PositionStatusesAndTasks.defaultProps = {
  positionId: undefined,
  accountId: undefined,
};
